import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { StammdatenService } from '../../stammdaten.service';
import { Entsorger, mergeKundenNrVvvosWithBetriebe } from '../entsorger';
import { Client } from '../../../client/classes/client';
import { MessageService } from '../../../../services/message-service/message.service';
import { Subscription } from 'rxjs';

@Component({
    selector: 'kiene-entsorger-kunden-nr-verwalten',
    templateUrl: './entsorger-kunden-nr-verwalten.component.html',
    styleUrls: ['./entsorger-kunden-nr-verwalten.component.scss'],
})
export class EntsorgerKundenNrVerwaltenComponent implements OnInit, OnDestroy {
    vvvoSubscription: Subscription;
    entsorgerSubscription: Subscription;
    isLoading = false;

    @Input('entsorger')
    entsorger: Entsorger;
    kunden: Client[] = [];
    redirectTo = 'einstellungen-stammdaten-entsorger';
    ersteinrichtung = false;

    @Input('dialog') dialog = false;

    @Output('saved') saved: EventEmitter<Entsorger> = new EventEmitter();

    constructor(
        private route: ActivatedRoute,
        private router: Router,
        private stammdatenService: StammdatenService,
        private messageService: MessageService,
    ) {}

    ngOnInit(): void {
        if (this.entsorger) {
            this.isLoading = false;
        }

        this.route.queryParams.subscribe(params => {
            this.ersteinrichtung = !!params.ersteinrichtung;
            if (this.ersteinrichtung) {
                this.redirectTo = 'registrierung-ersteinrichtung';
            }
        });

        this.route.params.subscribe(params => {
            if (params.entsorger_id) {
                this.entsorgerSubscription?.unsubscribe();
                this.entsorgerSubscription = this.stammdatenService.getEntsorger(params.entsorger_id).subscribe({
                    next: entsorger => {
                        this.isLoading = false;
                        this.entsorger = entsorger;
                        this.initVvvos();
                    },
                    error: err => {
                        this.isLoading = false;
                        this.messageService.errorMessage('Fehler!', err);
                    },
                });
            }
        });

        this.route.queryParams.subscribe(qp => {
            if (qp.redirectTo) {
                this.redirectTo = qp.redirectTo;
            }
        });
        this.initVvvos();
    }

    /**
     * sofern eine Route als queryParam ueber die URL mitgegeben wurde im Format aaa-bbb-ccc, wird dort hingeleitet
     */
    speichern() {
        this.isLoading = true;
        this.stammdatenService.updateEntsorger(this.entsorger).subscribe({
            next: resp => {
                this.isLoading = false;
                if (this.dialog) {
                    this.saved.emit(resp);
                } else {
                    if (this.redirectTo) {
                        this.router.navigate(['../../../'], { relativeTo: this.route }).then();
                    } else {
                        window.history.back();
                    }
                }
            },
            error: err => {
                this.messageService.errorMessage('Fehler!', err);
                this.isLoading = false;
            },
        });
    }

    ngOnDestroy(): void {
        this.vvvoSubscription?.unsubscribe();
        this.entsorgerSubscription?.unsubscribe();
    }

    private initVvvos() {
        if (!this.entsorger) {
            return;
        }
        if (!this.entsorger.kundenNrVvvos) {
            this.entsorger.kundenNrVvvos = [];
        }
        this.isLoading = true;
        this.vvvoSubscription?.unsubscribe();
        this.vvvoSubscription = this.stammdatenService.ladeMeineUndFreigegebeneVvvos().subscribe({
            next: vvvos => {
                this.isLoading = false;
                this.kunden = <Client[]>(vvvos?.records || []);
                this.entsorger.kundenNrVvvos = mergeKundenNrVvvosWithBetriebe(
                    this.entsorger.kundenNrVvvos,
                    this.kunden,
                );
            },
            error: err => {
                this.isLoading = false;
                this.messageService.errorMessage('Fehler!', err);
            },
        });
    }
}
